import { AdbCommandBase } from "@yume-chan/adb";
// frameworks/base/packages/SettingsProvider/src/com/android/providers/settings/SettingsService.java
export class Settings extends AdbCommandBase {
    // TODO: `--user <user>` argument
    base(command, namespace, ...args) {
        return this.adb.subprocess.spawnAndWaitLegacy(['settings', command, namespace, ...args]);
    }
    get(namespace, key) {
        return this.base('get', namespace, key);
    }
    delete(namespace, key) {
        return this.base('delete', namespace, key);
    }
    put(namespace, key, value, tag, makeDefault) {
        return this.base('put', namespace, key, value, ...(tag ? [tag] : []), ...(makeDefault ? ['default'] : []));
    }
    reset(namespace, modeOrPackageName, tag) {
        return this.base('reset', namespace, modeOrPackageName, ...(tag ? [tag] : []));
    }
    async list(namespace) {
        const output = await this.base('list', namespace);
        return output.split('\n');
    }
}
//# sourceMappingURL=settings.js.map